var PlayerStateMap = [
    ['unstarted', -1],
    ['ended', 0],
    ['playing', 1],
    ['paused', 2],
    ['buffering', 3],
    ['cued', 5]
];
var PlayerStates = new Map(PlayerStateMap);

export { PlayerStates };
